// extracted by mini-css-extract-plugin
export default {"invoicesHeader":"m_VVpy9ys9B00xbJorya","invoiceDivider":"hMd69keA02DkgCKNKC8Q"};